export default __webpack_public_path__ + "static/media/hills-with-white-notch-medium.b7dc9742.svg";